/*=========================================================================================
  File Name: actions.js
  Namespace: passes
  Description: Vuex Store - Pass actions
==========================================================================================*/
import {
  getPass,
  createPass,
  editPass,
  listPasses,
  addCourseToPass,
  deleteCourseToPass,
  addLPathToPass,
  deleteLPathToPass,
  addBootcampToPass,
  deleteBootcampToPass,
} from '@/services/passes.service'

const actions = {
  async getPassAction ({ commit }, { passId }) {
    const response = await getPass({
      passId
    })
    if (response) {
      commit('STORE_CURRENT_PASS', response)
    }
    return response
  },
  async getAllPasses({
    commit, rootState
  }, params = {}) {
    params.company = rootState.app.company
    const response = await listPasses(params)
    if (response) {
      commit('STORE_LIST_PASSES', response)
    }
    return response
  },
  async savePassToApi({
    commit, getters, rootState
  }) {
    let response
    if (getters.getCurrentPass.id) {
      response = await editPass({
        ...getters.getCurrentPass,
        passId: getters.getCurrentPass.id,
        company: rootState.app.company
      })
    } else {
      response = await createPass({
        ...getters.getCurrentPass,
        company: rootState.app.company
      })
    }
    commit('STORE_CURRENT_PASS', response)
    return response
  },
  savePassToStore({
    commit
  }, payload) {
    commit('STORE_CURRENT_PASS', payload)
  },
  resetCurrentPass({ commit }) {
    commit('RESET_CURRENT_PASS')
  },
  async saveCourseToPass({commit}, payload) {
    const response = await addCourseToPass({
      course_ids: payload.course_ids,
      passId: payload.passId
    })
    commit('courses/ADD_PASS_TO_COURSE_PASSES', payload.item, {
      root: true
    })
    return response
  },
  async removeCourseFromPass({commit}, payload) {
    const response = await deleteCourseToPass({
      courseId: payload.courseId,
      passId: payload.passId
    })
    commit('courses/REMOVE_PASS_FROM_COURSE_PASSES', payload.item, {
      root: true
    })
    return response
  },
  async saveLPathToPass({ commit }, payload) {
    const response = await addLPathToPass({
      lpath_ids: payload.lpath_ids,
      passId: payload.passId
    })
    commit('lpaths/ADD_PASS_TO_LPATH_PASSES', payload.item, {
      root: true
    })
    return response
  },
  async removeLPathFromPass({ commit }, payload) {
    const response = await deleteLPathToPass({
      lpathId: payload.lpathId,
      passId: payload.passId
    })
    commit('lpaths/REMOVE_PASS_FROM_LPATH_PASSES', payload.item, {
      root: true
    })
    return response
  },
  async saveBootcampToPass({ commit }, payload) {
    const response = await addBootcampToPass({
      bootcamp_ids: payload.bootcamp_ids,
      passId: payload.passId
    })
    commit('bootcamps/ADD_PASS_TO_BOOTCAMP_PASSES', payload.item, {
      root: true
    })
    return response
  },
  async removeBootcampFromPass({ commit }, payload) {
    const response = await deleteBootcampToPass({
      bootcampId: payload.bootcampId,
      passId: payload.passId
    })
    commit('bootcamps/REMOVE_PASS_FROM_BOOTCAMP_PASSES', payload.item, {
      root: true
    })
    return response
  }
}

export default actions
